import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../guards/role.guard';
import {
	AddEmployeeComponent,
	AdminDashboardComponent,
	DashboardComponent,
	PageNotFoundComponent,
	PayCategoriesComponent,
	PayCategoriesDetailsComponent,
	PayScalesOverviewComponent,
	PayScalesComponent,
	PayScalesDetailsComponent,
	PilotpayComponent,
	TimeSheetsComponent,
	OverrideEmployeesComponent
} from './index';
import { PayScalesSettingsComponent } from './pay-scales/settings/pay-scales-settings.component';
import { OfflineComponent } from './offline/offline.component';
import { JobTitlesComponent } from './job-titles/job-titles.component';
import { JobTitlesDetailsComponent } from './job-titles/details/job-titles-details.component';
import { AircraftModelsComponent } from './aircraft-models/aircraft-models.component';
import { AircraftModelsDetailsComponent } from './aircraft-models/details/aircraft-models-details.component';
import { UserGuard } from '../guards/user.guard';

// tslint:disable-next-line:no-any
export const authProviders: any = [RoleGuard, UserGuard];

const pilotpayRoutes: Routes = [
	{
		path: '',
		component: PilotpayComponent,
		canActivate: [UserGuard],
		children: [
			{
				path: 'add-employee',
				component: AddEmployeeComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Add Employee'
				}
			},
			{
				path: 'admin',
				component: AdminDashboardComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Dashboard',
					reuse: true
				}
			},
			{
				path: 'dashboard',
				component: DashboardComponent,
				pathMatch: 'full',
				data: {
					title: 'Dashboard'
				}
			},
			{
				path: 'time-sheets/:employeeId',
				component: TimeSheetsComponent,
				pathMatch: 'full',
				data: {
					title: 'Time Sheets'
				}
			},
			{
				path: 'pay-scales',
				component: PayScalesOverviewComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Pay Tables'
				}
			},
			{
				path: 'pay-scales/settings',
				component: PayScalesSettingsComponent,
				pathMatch: 'full',
				data: {
					title: 'Pay Tables'
				}
			},
			{
				path: 'pay-scales/overview/:id',
				component: PayScalesComponent,
				pathMatch: 'full',
				data: {
					title: 'Pay Tables'
				}
			},
			{
				path: 'pay-scales/:id',
				component: PayScalesDetailsComponent,
				pathMatch: 'full',
				data: {
					title: 'Pay Tables'
				}
			},
			{
				path: 'pay-categories',
				component: PayCategoriesComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Pay Categories'
				}
			},
			{
				path: 'pay-categories/:id/:categoriesType/:date',
				component: PayCategoriesDetailsComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Pay Categories'
				}
			},
			{
				path: 'job-titles',
				component: JobTitlesComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Job Titles'
				}
			},
			{
				path: 'job-titles/details/:id',
				component: JobTitlesDetailsComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Job Titles'
				}
			},
			{
				path: 'aircraft-models',
				component: AircraftModelsComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Aircraft Models'
				}
			},
			{
				path: 'aircraft-models/details/:id',
				component: AircraftModelsDetailsComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Aircraft Models'
				}
			},
			{
				path: 'job-titles/details/archived/:id',
				component: JobTitlesDetailsComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Job Titles'
				}
			},
			{
				path: 'aircraft-models/details/archived/:id',
				component: AircraftModelsDetailsComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Aircraft Models'
				}
			},
			{
				path: 'override-employees',
				component: OverrideEmployeesComponent,
				canActivate: [RoleGuard],
				pathMatch: 'full',
				data: {
					title: 'Edit Employees',
					reuse: true
				}
			},
			{
				path: 'notifications',
				loadChildren: () => import('../notifications/notifications.module').then(m => m.NotificationsModule)
				// loadChildren: () => import('../notifications/notifications.module').then(mod => mod.NotificationsModule)
			},
			{
				path: 'offline',
				component: OfflineComponent,
				pathMatch: 'full'
			},
			{
				path: '**',
				component: PageNotFoundComponent,
				data: {
					title: 'Not Found'
				}
			}
		]
	}
];

export { pilotpayRoutes };

/**
 * PilotpayRoutingModule
 */
@NgModule({
	imports: [RouterModule.forChild(pilotpayRoutes), CommonModule],
	exports: [RouterModule]
})

/**
 * PilotpayRoutingModule
 */
export class PilotpayRoutingModule {}
